import styled, { css } from 'styled-components'

const Main = styled.main`
  background-color: white;
`

const Hero2 = styled.section`
  ${({ theme }) => css`
    position: relative;
    z-index: 1;
    padding: ${theme.spacing(5)} ${theme.spacing(7)};
    min-height: calc(100vh - 400px);
    display: flex;
    align-items: center;
    ${theme.media('xs')} {
      padding: ${theme.spacing(5)} ${theme.spacing(15)};
    }

    ${theme.media('sm')} {
      padding: ${theme.spacing(10)} ${theme.spacing(10)} ${theme.spacing(7)};
      min-height: calc(100vh - 269px);
    }
    ${theme.media('md')} {
      min-height: calc(100vh - 269px);
    }

    .pattern {
      position: absolute;
      top: 0;
      left: 0;
      height: 100%;
      width: 100%;
      background-image: linear-gradient(180deg, #f3f3f3 0%, #f3f3f3 76.56%, #e6e6e6 81.25%, #e6e6e6 100%);
      z-index: -1;
    }
  `}
`

const HeroInner2 = styled.div`
  ${({ theme }) => css`
    max-width: 60rem;
    margin: 0 auto;
    text-align: center;
    gap: ${theme.spacing(0)};

    border-radius: 3px;

    ${theme.media('sm')} {
      gap: ${theme.spacing(2)};

      background-color: white;
      padding: ${theme.spacing(10)} ${theme.spacing(10)} ${theme.spacing(7)};
    }
    img {
      flex-shrink: 0;
      max-width: 20rem;
      margin-bottom: ${theme.spacing(4)};
    }
  `}
`

const HeroContent2 = styled.div`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing(2)};

    ${theme.media('sm')} {
      gap: ${theme.spacing(1)};
    }
    h1 {
      margin: 0 0 ${theme.spacing(2)};
      font-size: 4rem;

      ${theme.media('md')} {
        font-size: 4.6rem;
      }

      ${theme.media('lg')} {
        font-size: 5.2rem;
      }
    }

    p {
      margin: 0;
      font-size: 1.8rem;
      font-weight: 300;
      opacity: 0.9;

      ${theme.media('sm')} {
        margin-bottom: ${theme.spacing(5)};
      }

      ${theme.media('md')} {
        margin-bottom: ${theme.spacing(7)};
        font-size: 2.1rem;
      }

      &.home_pretitle {
        margin-bottom: ${theme.spacing(1)};
      }

      &.outroText {
        font-size: 1.6rem;
      }
    }
  `}
`

const Sponsor = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: ${theme.spacing(2)};
    padding: ${theme.spacing(2.5)} 0;
    font-size: 1.4rem;
  `}
`

const StepSection = styled.section`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing(5)};
    max-width: 104.2rem;
    padding: ${theme.spacing(4)};
    margin: 0 auto;
    text-align: center;

    h4 {
      margin: 0;
      text-align: center;
    }

    ${theme.maxMedia('sm')} {
      ol {
        padding-left: 0;
      }
    }

    ${theme.media('xs')} {
      padding: ${theme.spacing(5)} ${theme.spacing(8)};
    }

    ${theme.media('md')} {
      padding: ${theme.spacing(5)} ${theme.spacing(10)};
    }
  `}
`
const FooterTerms = styled.section`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing(5)};
    max-width: 104.2rem;
    padding: ${theme.spacing(4)};
    margin: 0 auto;
    text-align: center;

    .smallText {
      font-size: 1.3rem;
      color: ${theme.palette.grey[500]};
    }
  `}
`
export default {
  Main,
  Hero2,
  HeroInner2,
  HeroContent2,
  StepSection,
  Sponsor,
  FooterTerms,
}
